import { render, staticRenderFns } from "./storeRecommendList.vue?vue&type=template&id=b86eef34&scoped=true&"
import script from "./storeRecommendList.vue?vue&type=script&lang=js&"
export * from "./storeRecommendList.vue?vue&type=script&lang=js&"
import style0 from "./storeRecommendList.vue?vue&type=style&index=0&id=b86eef34&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86eef34",
  null
  
)

export default component.exports